import styled from "styled-components";


export const KnowledgeGraphStyle = styled.div`
    width: 26%;
    height: fit-content;
    padding-bottom: 20px;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
`;